import { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { isDepositInvoice } from './depositInvoices/isDepositInvoice'
import { isFinalInvoice } from './depositInvoices/isFinalInvoice'

export type TrackingDocumentType = InvoiceDocumentType | 'depositInvoice' | 'finalInvoice'

// Only overrides the tracked documentType for deposit/final invoices,
// because those are not documentTypes in the API
export const getTrackingDocumentType = ({
  billingStage,
  documentType,
}: {
  billingStage?: InvoiceBillingStage
  documentType?: InvoiceDocumentType
}): TrackingDocumentType | undefined => {
  if (isDepositInvoice(billingStage)) {
    return 'depositInvoice'
  }

  if (isFinalInvoice(billingStage)) {
    return 'finalInvoice'
  }

  return documentType
}
